<template>
    <div>
    </div>
</template>

<script>
    export default {
        name:'DefaultOperatorInfoPane',
        data () {
            return {
            }
        },
        
        computed:{
            
        }
    }
</script>

</<style>
</style>
